export const SETTING_COMMAND_COLUMN = 'SETTING_COMMAND_COLUMN';
export const SETTING_COMMAND_INDEX = 'SETTING_COMMAND_INDEX';
export const SETTING_COMMAND_LOADING_INDEX = 'SETTING_COMMAND_LOADING_INDEX';
export const SETTING_COMMAND_LOADING_SHOW = 'SETTING_COMMAND_LOADING_SHOW';
export const SETTING_COMMAND_OPTION = 'SETTING_COMMAND_OPTION';
export const SETTING_COMMAND_RESET = 'SETTING_COMMAND_RESET';
export const SETTING_COMMAND_SEARCH = 'SETTING_COMMAND_SEARCH';
export const SETTING_COMMAND_SHOW = 'SETTING_COMMAND_SHOW';
export const SETTING_COMMAND_RECORD = 'SETTING_COMMAND_RECORD';
